<template>
  <div class="emailpopup" v-if="emailPopupVisible">
    <div class="emailheader">
      <span
        >Email verzenden naar:
        <span class="emailto"
          >{{ sendToPerson[0].email }} |
          <strong
            >{{ sendToPerson[0].voornaam }}
            {{ sendToPerson[0].achternaam }}</strong
          ></span
        ></span
      >
      <div class="header-buttons">
        <div class="close-btn" @click="closePopup">
          <img src="../assets/close-btn.png" alt="" class="close-x" />
        </div>
      </div>
    </div>
    <div class="emailsubject">
      Onderwerp: <input class="subject" type="text" v-model="subjectTekst" />
    </div>
    <div class="emailbody">
      <textarea class="textareaemail" v-model="bodyTekst" name="description">
            Type hier de email uit
         </textarea
      >
      <button @click="triggerSend" class="emailbutton">
        Verzend email
      </button>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'EmailPopup',
  data () {
    return {
      bodyTekst: '',
      subjectTekst: ''
    }
  },
  computed: {
    ...mapGetters(['allTekenaars', 'allOpdrachten']),
    emailPopupVisible () {
      return store.getters.emailPopupVisible
    },
    emailInfo () {
      return store.getters.emailInfo
    },
    sendToPerson () {
      return this.allTekenaars.filter(tekenaar => {
        if (tekenaar.id == this.emailInfo.sendToId) {
          return tekenaar
        }
      })
    },
    log () {
      return this.sendToPerson[0].log
    }
  },
  methods: {
    closePopup () {
      store.commit('SET_EMAILPOPUP_VISIBILITY', false)
    },
    triggerSend () {
      let payload = {
        subject: this.subjectTekst,
        bodytekst: this.bodyTekst
      }
      store
        .dispatch('sendRegularEmail', {
          bodyTekst: this.bodyTekst,
          subjectTekst: this.subjectTekst,
          sendToEmail: this.sendToPerson[0].email
        })
        .then(() => {
          this.setLog(payload)
          this.bodyTekst = ''
          this.subjectTekst = ''
          this.closePopup()
        })
    },
    setLog (payload) {
      var maxid = 0
      if (Array.isArray(this.log)) {
        this.log.map(function (obj) {
          if (obj.id > maxid) maxid = obj.id
        })
      }
      const newlog = {
        timestamp: Date.now(),
        id: maxid + 1,
        log: 'Email verstuurd met onderwerp: ' + payload.subject,
        body: payload.bodytekst
      }
      const payloadLog = {
        id: this.sendToPerson[0].id,
        log: newlog
      }
      store.dispatch('updateTekLog', payloadLog)
    }
  }
}
</script>

<style>
.emailsubject {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgb(00, 00, 00, 0.2);
  padding: 30px;
}
.subject {
  padding: 10px;
  font-size: 16px;
  width: 100%;
  border: none;
}
.emailto {
  background-color: rgb(00, 00, 00, 0.1);
  padding: 4px 8px;
  margin-left: 5px;
  border-radius: 4px;
}
.textareaemail {
  width: 100%;
  font-size: 16px;
  border: none;
}
.emailpopup {
  position: fixed;
  top: 50px;
  display: flex;
  flex-direction: column;
  bottom: 50px;
  left: 50px;
  right: 50px;
  background-color: white;
  z-index: 999;
  border-radius: 20px;
  box-shadow: 0 100px 600px rgb(00, 00, 00, 0.5);
}

.emailheader {
  padding: 30px;
  border-bottom: 1px solid rgb(00, 00, 00, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.emailbody {
  padding: 30px;
  position: relative;
  height: 100%;
  display: flex;
}
.close-btn {
  max-width: 40px;
  cursor: pointer;
}

.emailbutton {
  position: absolute;
  bottom: 30px;
  padding: 15px;
  background-color: #3076ea;
  border: none;
  cursor: pointer;
  border-radius: 6px;
  color: white;
  font-weight: 600;
  font-size: 16px;
  transition: 0.2s;
}
.emailbutton:hover {
  opacity: 0.8;
}
</style>
